import { MessageType } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../../translations';
import { PrescriptionStatus } from '../../common/PrescriptionStatus';

export const MedicineParametersChangedStatus = (): JSX.Element => {
   return (
      <PrescriptionStatus
         type={MessageType.WARNING}
         label={draftPrescriptionsTranslationKeys.verifyMedicineParametersChanges}
         testId={'medicineParametersChanged'}
      />
   );
};
